// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pc-c";
export var backButton = "_pc-4";
export var backIcon = "_pc-5";
export var chevronShortcut = "_pc-6";
export var container = "_pc-1";
export var editor = "_pc-8";
export var editorWrapper = "_pc-7";
export var prefix = "_pc-2";
export var searchIcon = "_pc-3";
export var suffix = "_pc-9";
export var suffixContent = "_pc-a";
export var suffixText = "_pc-b";
export var wrapper = "_pc-0";